import styled from '../../../styles/styledComponents/themeComponents';

export const ExcelTableStyle = styled.div`
  .item-counter {
    font-weight: 700;

    span {
      color: #6200ea;
    }
  }

  .button-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 16px;

    .amondz-button {
      display: flex;
      align-items: center;
    }

    .right,
    .left {
      display: flex;
      gap: 20px;
    }
  }

  ._amondz-table-summary {
    display: none;
  }

  ._amondz-table {
    .ant-table-body {
      max-height: 545px;
    }
  }

  .ellipsis {
    ${(props) => props.theme.ellipsis}
  }
`;
